'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import { getComponentPropType } from '../utils/propTypes/componentProp';
import devLogger from 'react-utils/devLogger';
import { rgba } from '../core/Color';
import { PANTERA } from 'HubStyleTokens/colors';
import UIDialogCloseButton from '../dialog/UIDialogCloseButton';
import UIDialogFooter from '../dialog/UIDialogFooter';
import UIImage from '../image/UIImage';
import UIModal from '../dialog/UIModal';
const LIGHTBOX_PADDING = '70px';
const StyledModalBody = styled.div.withConfig({
  displayName: "UILightbox__StyledModalBody",
  componentId: "x4622f-0"
})(["&&{display:block;height:100%;padding:", ";word-wrap:break-word;}"], LIGHTBOX_PADDING);
const FooterWrapper = styled.div.withConfig({
  displayName: "UILightbox__FooterWrapper",
  componentId: "x4622f-1"
})(["bottom:0;color:inherit;position:absolute;width:100%;"]);
const LightboxFooter = styled(UIDialogFooter).withConfig({
  displayName: "UILightbox__LightboxFooter",
  componentId: "x4622f-2"
})(["&&{background-color:", ";color:inherit;padding-left:", ";padding-right:", ";}"], rgba(PANTERA, 0.89), LIGHTBOX_PADDING, LIGHTBOX_PADDING);
const LightboxImage = styled(UIImage).withConfig({
  displayName: "UILightbox__LightboxImage",
  componentId: "x4622f-3"
})(["&&{height:100%;margin:auto;}"]);

const DefaultFooterComponent = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/_jsx(LightboxFooter, {
    align: "between",
    layout: "default",
    children: children
  });
};

class UILightbox extends Component {
  render() {
    const _this$props = this.props,
          {
      children,
      closeable,
      FooterComponent,
      imageAlt,
      ImageComponent,
      imageSrc,
      onClose
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "closeable", "FooterComponent", "imageAlt", "ImageComponent", "imageSrc", "onClose"]);

    if (process.env.NODE_ENV !== 'production') {
      if (imageSrc && !imageAlt) {
        devLogger.warn({
          message: 'UILightbox: for better accessibility, please include a description ' + 'of the image in the `imageAlt` prop .',
          key: 'UILightbox: missing imageAlt prop'
        });
      }
    }

    return /*#__PURE__*/_jsxs(UIModal, Object.assign({}, rest, {
      use: "lightbox",
      children: [closeable && /*#__PURE__*/_jsx(UIDialogCloseButton, {
        size: "lg",
        detached: true,
        onClick: onClose
      }), /*#__PURE__*/_jsx(StyledModalBody, {
        children: /*#__PURE__*/_jsx(ImageComponent, {
          alt: imageAlt,
          objectFit: "contain",
          src: imageSrc
        })
      }), /*#__PURE__*/_jsx(FooterWrapper, {
        children: children && /*#__PURE__*/_jsx(FooterComponent, {
          children: children
        })
      })]
    }));
  }

}

UILightbox.displayName = 'UILightbox';
UILightbox.propTypes = {
  children: PropTypes.node,
  closeable: PropTypes.bool.isRequired,
  FooterComponent: getComponentPropType(UIDialogFooter),
  ImageComponent: getComponentPropType(UIImage),
  imageAlt: PropTypes.string,
  imageSrc: PropTypes.string,
  onClose: PropTypes.func
};
UILightbox.defaultProps = {
  closeable: true,
  FooterComponent: DefaultFooterComponent,
  ImageComponent: LightboxImage
};
export default UILightbox;